import { render } from "./AttachmentEdit.vue?vue&type=template&id=7a3bdccc"
import script from "./AttachmentEdit.vue?vue&type=script&lang=js"
export * from "./AttachmentEdit.vue?vue&type=script&lang=js"

import "./AttachmentEdit.vue?vue&type=style&index=0&id=7a3bdccc&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__